<div *ngIf="compact" class="content compact rv-rows rv-scrollable">
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
<div
  *ngIf="!compact"
  animatedSize
  class="content"
  [ngClass]="{ wide: wide, 'full-page': fullPage }"
  [style.width]="outerWidth"
>
  <div
    class="header-container"
    [ngClass]="invertedColors ? 'inverted' : 'null'"
  >
    <div class="header-inner-container">
      <div class="rv-flex flex-nowrap">
        <h5 class="rv-title-05">{{ title }}</h5>
        <button
          rivButton
          [variant]="'ghost'"
          [size]="'large'"
          class="close"
          title="Close"
          [rivTooltip]="'Close'"
          type="button"
          (click)="
            $event.preventDefault(); setCloseMethod('X out'); close.emit()
          "
          [icon]="'X'"
        ></button>
      </div>
      <ng-content select=".header-extras"></ng-content>
    </div>
    <ng-content select="[header-bottom]"></ng-content>
  </div>
  <div
    class="body"
    [ngClass]="invertedColors ? 'inverted' : 'null'"
    [class.allow-overflow]="allowOverflow"
    [class.no-scroll]="noScroll"
    [style.width]="width"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
  <div
    *ngIf="!overrideFooter"
    class="rv-rows large outer footer"
    [ngClass]="invertedColors ? 'inverted' : 'null'"
  >
    <ng-content select="footer"></ng-content>
  </div>
</div>
<!-- https://stackoverflow.com/a/58507050 -->
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
